<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <md-steppers :md-active-step.sync="active" md-alternative md-linear>
                        <md-step id="first" md-label="Dados de Conexão" :md-error="firstStepError" :md-done.sync="first">
                            <b-form @submit="onConnection" novalidate="novalidate">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-4 offset-md-3">
                                            <div class="form-group bmd-form-group"
                                                 v-bind:class="{'is-filled': form.step1.hostname != '', 'has-danger' : validation.step1.hostname != '' }">
                                                <label for="hostname" class="bmd-label-floating">Server (Hostname/IP) *</label>
                                                <input refs="hostname" type="text" class="form-control" v-model="form.step1.hostname" />
                                                <label v-if="validation.step1.hostname != ''" id="hostname-error" class="error" for="hostname">{{ validation.step1.hostname }}</label>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group bmd-form-group"
                                                 v-bind:class="{'is-filled': form.step1.port != '', 'has-danger' : validation.step1.port != '' }">
                                                <label for="port" class="bmd-label-floating">Porta *</label>
                                                <input refs="port" type="text" class="form-control" v-model="form.step1.port" />
                                                <label v-if="validation.step1.port != ''" id="port-error" class="error" for="port">{{ validation.step1.port }}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6 offset-md-3">
                                            <div class="form-group bmd-form-group"
                                                 v-bind:class="{'is-filled': form.step1.username != '', 'has-danger' : validation.step1.username != '' }">
                                                <label for="username" class="bmd-label-floating">User Name *</label>
                                                <input refs="username" type="text" class="form-control" v-model="form.step1.username" />
                                                <label v-if="validation.step1.username != ''" id="username-error" class="error" for="username">{{ validation.step1.username }}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6 offset-md-3">
                                            <div class="form-group bmd-form-group"
                                                 v-bind:class="{'is-filled': form.step1.password != '', 'has-danger' : validation.step1.password != '' }">
                                                <label for="password" class="bmd-label-floating">Password</label>
                                                <input refs="password" type="password" class="form-control" v-model="form.step1.password" />
                                                <label v-if="validation.step1.password != ''" id="password-error" class="error" for="password">{{ validation.step1.password }}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6 offset-md-3">
                                            <div class="form-group bmd-form-group"
                                                 v-bind:class="{'is-filled': form.step1.dbname != '', 'has-danger' : validation.step1.dbname != '' }">
                                                <label for="dbname" class="bmd-label-floating">Database *</label>
                                                <input refs="dbname" type="text" class="form-control" v-model="form.step1.dbname" />
                                                <label v-if="validation.step1.dbname != ''" id="dbname-error" class="error" for="dbname">{{ validation.step1.dbname }}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <button type="submit" class="btn btn-rose">
                                        <span class="btn-label"><i class="material-icons">done</i></span>
                                        Conectar
                                    </button>
                                </div>
                            </b-form>
                        </md-step>
                        <md-step id="second" md-label="Configurações da Importação" :md-done.sync="second">
                            <b-form @submit="onConfig" novalidate="novalidate">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-4 offset-md-3">
                                            <md-list>
                                                <md-list-item>
                                                    <b-form-checkbox v-model="form.step2.administrators" :value="true" :unchecked-value="false">
                                                        <span class="md-list-item-text">Administradoras</span>
                                                    </b-form-checkbox>
                                                    <b-badge pill variant="dark">{{ numAdministrators }}</b-badge>
                                                </md-list-item>
                                                <md-list-item>
                                                    <b-form-checkbox v-model="form.step2.branches" :value="true" :unchecked-value="false">
                                                        <span class="md-list-item-text">Filiais</span>
                                                    </b-form-checkbox>
                                                    <b-badge pill variant="dark">{{ numBranches }}</b-badge>
                                                </md-list-item>
                                                <md-list-item>
                                                    <b-form-checkbox v-model="form.step2.clients" :value="true" :unchecked-value="false">
                                                        <span class="md-list-item-text">Clientes</span>
                                                    </b-form-checkbox>
                                                    <b-badge pill variant="dark">{{ numClients }}</b-badge>
                                                </md-list-item>
                                                <md-list-item>
                                                    <b-form-checkbox v-model="form.step2.teams" :value="true" :unchecked-value="false">
                                                        <span class="md-list-item-text">Equipes</span>
                                                    </b-form-checkbox>
                                                    <b-badge pill variant="dark">{{ numTeams }}</b-badge>
                                                </md-list-item>
                                                <md-list-item>
                                                    <b-form-checkbox v-model="form.step2.manufacturers" :value="true" :unchecked-value="false">
                                                        <span class="md-list-item-text">Fabricantes</span>
                                                    </b-form-checkbox>
                                                    <b-badge pill variant="dark">{{ numManufacturers }}</b-badge>
                                                </md-list-item>
                                                <md-list-item>
                                                    <b-form-checkbox v-model="form.step2.groups" :value="true" :unchecked-value="false">
                                                        <span class="md-list-item-text">Grupos</span>
                                                    </b-form-checkbox>
                                                    <b-badge pill variant="dark">{{ numGroups }}</b-badge>
                                                </md-list-item>
                                                <md-list-item>
                                                    <b-form-checkbox v-model="form.step2.medias" :value="true" :unchecked-value="false">
                                                        <span class="md-list-item-text">Mídias</span>
                                                    </b-form-checkbox>
                                                    <b-badge pill variant="dark">{{ numMedias }}</b-badge>
                                                </md-list-item>
                                                <md-list-item>
                                                    <b-form-checkbox v-model="form.step2.models" :value="true" :unchecked-value="false">
                                                        <span class="md-list-item-text">Modelos</span>
                                                    </b-form-checkbox>
                                                    <b-badge pill variant="dark">{{ numModels }}</b-badge>
                                                </md-list-item>
                                                <md-list-item>
                                                    <b-form-checkbox v-model="form.step2.profiles" :value="true" :unchecked-value="false">
                                                        <span class="md-list-item-text">Perfis</span>
                                                    </b-form-checkbox>
                                                    <b-badge pill variant="dark">{{ numProfiles }}</b-badge>
                                                </md-list-item>
                                                <md-list-item>
                                                    <b-form-checkbox v-model="form.step2.proposals" :value="true" :unchecked-value="false">
                                                        <span class="md-list-item-text">Propostas</span>
                                                    </b-form-checkbox>
                                                    <b-badge pill variant="dark">{{ numProposals }}</b-badge>
                                                </md-list-item>
                                                <md-list-item>
                                                    <b-form-checkbox v-model="form.step2.users" :value="true" :unchecked-value="false">
                                                        <span class="md-list-item-text">Usuários</span>
                                                    </b-form-checkbox>
                                                    <b-badge pill variant="dark">{{ numUsers }}</b-badge>
                                                </md-list-item>
                                            </md-list>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <button type="submit" class="btn btn-rose">
                                        <span class="btn-label"><i class="material-icons">done</i></span>
                                        Importar
                                    </button>
                                </div>
                            </b-form>
                        </md-step>
                        <md-step id="third" md-label="Carregando dados" :md-done.sync="third">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6 offset-md-3">
                                        <md-list>
                                            <md-list-item v-if="form.step2.administrators" :class="{'list-group-item-danger': !administrators, 'list-group-item-success': administrators}">
                                                <span class="md-list-item-text">Administradoras</span>
                                                <md-icon>{{ administrators ? 'verified_user' : 'error' }}</md-icon>
                                            </md-list-item>
                                            <md-list-item v-if="form.step2.branches" :class="{'list-group-item-danger': !branches, 'list-group-item-success': branches}">
                                                <span class="md-list-item-text">Filiais</span>
                                                <md-icon>{{ branches ? 'verified_user' : 'error' }}</md-icon>
                                            </md-list-item>
                                            <md-list-item v-if="form.step2.clients" :class="{'list-group-item-danger': !clients, 'list-group-item-success': clients}">
                                                <span class="md-list-item-text">Clientes</span>
                                                <md-icon>{{ clients ? 'verified_user' : 'error' }}</md-icon>
                                            </md-list-item>
                                            <md-list-item v-if="form.step2.teams" :class="{'list-group-item-danger': !teams, 'list-group-item-success': teams}">
                                                <span class="md-list-item-text">Equipes</span>
                                                <md-icon>{{ teams ? 'verified_user' : 'error' }}</md-icon>
                                            </md-list-item>
                                            <md-list-item v-if="form.step2.manufacturers" :class="{'list-group-item-danger': !manufacturers, 'list-group-item-success': manufacturers}">
                                                <span class="md-list-item-text">Fabricantes</span>
                                                <md-icon>{{ manufacturers ? 'verified_user' : 'error' }}</md-icon>
                                            </md-list-item>
                                            <md-list-item v-if="form.step2.groups" :class="{'list-group-item-danger': !groups, 'list-group-item-success': groups}">
                                                <span class="md-list-item-text">Grupos</span>
                                                <md-icon>{{ groups ? 'verified_user' : 'error' }}</md-icon>
                                            </md-list-item>
                                            <md-list-item v-if="form.step2.medias" :class="{'list-group-item-danger': !medias, 'list-group-item-success': medias}">
                                                <span class="md-list-item-text">Mídias</span>
                                                <md-icon>{{ medias ? 'verified_user' : 'error' }}</md-icon>
                                            </md-list-item>
                                            <md-list-item v-if="form.step2.models" :class="{'list-group-item-danger': !models, 'list-group-item-success': models}">
                                                <span class="md-list-item-text">Modelos</span>
                                                <md-icon>{{ models ? 'verified_user' : 'error' }}</md-icon>
                                            </md-list-item>
                                            <md-list-item v-if="form.step2.profiles" :class="{'list-group-item-danger': !profiles, 'list-group-item-success': profiles}">
                                                <span class="md-list-item-text">Perfis</span>
                                                <md-icon>{{ profiles ? 'verified_user' : 'error' }}</md-icon>
                                            </md-list-item>
                                            <md-list-item v-if="form.step2.proposals" :class="{'list-group-item-danger': !proposals, 'list-group-item-success': proposals}">
                                                <span class="md-list-item-text">Propostas</span>
                                                <md-icon>{{ proposals ? 'verified_user' : 'error' }}</md-icon>
                                            </md-list-item>
                                            <md-list-item v-if="form.step2.users" :class="{'list-group-item-danger': !users, 'list-group-item-success': users}">
                                                <span class="md-list-item-text">Usuários</span>
                                                <md-icon>{{ users ? 'verified_user' : 'error' }}</md-icon>
                                            </md-list-item>
                                        </md-list>
                                        <b-alert v-if="messageError != null" show variant="danger">
                                            <h4 class="alert-heading">Falhas da importação</h4>
                                            <hr />
                                            <p v-html="messageError"></p>
                                        </b-alert>
                                    </div>
                                </div>
                            </div>
                        </md-step>
                    </md-steppers>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import Import from "@/services/modules/import_old_version";

    export default {
        data() {
            return {
                active: 'first',
                administrators: true,
                branches: true,
                clients: true,
                first: false,
                firstStepError: null,
                form: {
                    step1: {
                        dbname: "consyst_old",
                        hostname: "database",
                        password: "",
                        port: 3306,
                        username: "root"
                    },
                    step2: {
                        administrators: true,
                        branches: true,
                        clients: true,
                        groups: true,
                        manufacturers: true,
                        medias: true,
                        models: true,
                        profiles: true,
                        proposals: true,
                        users: true,
                        teams: true
                    }
                },
                groups: true,
                manufacturers: true,
                medias: true,
                messageError: null,
                models: true,
                numAdministrators: 0,
                numBranches: 0,
                numClients: 0,
                numGroups: 0,
                numManufacturers: 0,
                numMedias: 0,
                numModels: 0,
                numProfiles: 0,
                numProposals: 0,
                numUsers: 0,
                numTeams: 0,
                profiles: true,
                proposals: true,
                second: false,
                secondStepError: null,
                teams: true,
                third: false,
                thirdStepeError: null,
                users: true,
                validation: {
                    step1: {
                        dbname: "",
                        hostname: "",
                        password: "",
                        port: "",
                        username: ""
                    }
                }
            };
        },
        methods: {
            onConfig(_ev) {
                _ev.preventDefault();

                var self = this;
                var form = self.form.step1;
                var validation = self.validation.step1;
                var valid = true;

                self.firstStepError = null;
                validation.dbname = "";
                validation.hostname = "";
                validation.password = "";
                validation.port = "";
                validation.username = "";

                if (form.hostname == "") {
                    validation.hostname = "Server é obrigatório!";
                    valid = false;
                }
                if (form.port == "") {
                    validation.port = "Porta é obrigatória!";
                    valid = false;
                }
                if (form.username == "") {
                    validation.username = "User name é obrigatório!";
                    valid = false;
                }
                if (form.dbname == "") {
                    validation.dbname = "Database é obrigatório!";
                    valid = false;
                }

                if (valid) {
                    self.$root.$emit("onLoading");

                    const connection = Import.connect(form);

                    connection.then(function () {
                        const load = Import.do(self.form);

                        load.then(function (_data) {
                            self.$root.$emit("onLoading");
                            
                            self.administrators = _data.administrators;
                            self.branches = _data.branches;
                            self.clients = _data.clients;
                            self.groups = _data.groups;
                            self.manufacturers = _data.manufacturers;
                            self.medias = _data.medias;
                            self.models = _data.models;
                            self.profiles = _data.profiles;
                            self.proposals = _data.proposals;
                            self.users = _data.users;
                            self.teams = _data.teams;

                            self.second = true;
                            self.active = "third";
                        });

                        load.catch(function (_return) {
                            var data = _return.data;
                            self.$root.$emit("onLoading");

                            self.administrators = data.administrators;
                            self.branches = data.branches;
                            self.clients = data.clients;
                            self.groups = data.groups;
                            self.manufacturers = data.manufacturers;
                            self.medias = data.medias;
                            self.models = data.models;
                            self.profiles = data.profiles;
                            self.proposals = data.proposals;
                            self.users = data.users;
                            self.teams = data.teams;
                            self.messageError = data.message;
                            
                            self.second = true;
                            self.active = "third";
                        });
                    });

                    connection.catch(function (_return) {
                        var data = _return.data;
                        self.$root.$emit("onLoading");
                        self.$notify.error(data.message);

                        self.first = false;
                        self.active = "first";
                        self.firstStepError = "Ops!";
                    });
                } else {
                    self.first = false;
                    self.active = "first";
                    self.firstStepError = "Ops!";
                }

            },
            onConnection(_ev) {
                _ev.preventDefault();

                var self = this;
                var form = self.form.step1;
                var validation = self.validation.step1;
                var valid = true;

                // Reset itens
                self.firstStepError = null;
                validation.dbname = "";
                validation.hostname = "";
                validation.password = "";
                validation.port = "";
                validation.username = "";

                if (form.hostname == "") {
                    validation.hostname = "Server é obrigatório!";
                    valid = false;
                }
                if (form.port == "") {
                    validation.port = "Porta é obrigatória!";
                    valid = false;
                }
                if (form.username == "") {
                    validation.username = "User name é obrigatório!";
                    valid = false;
                }
                if (form.dbname == "") {
                    validation.dbname = "Database é obrigatório!";
                    valid = false;
                }

                if (valid) {
                    self.$root.$emit("onLoading");

                    const response = Import.connect(form);

                    response.then(function (_data) {
                        self.numAdministrators = _data.administrators;
                        self.numBranches = _data.branches;
                        self.numClients = _data.clients;
                        self.numGroups = _data.groups;
                        self.numManufacturers = _data.manufacturers;
                        self.numMedias = _data.medias;
                        self.numModels = _data.models;
                        self.numProfiles = _data.profiles;
                        self.numProposals = _data.proposals;
                        self.numUsers = _data.users;
                        self.numTeams = _data.teams;
                        self.$root.$emit("onLoading");

                        self.first = true;
                        self.active = "second";
                    });

                    response.catch(function (_return) {
                        var data = _return.data;
                        self.$root.$emit("onLoading");
                        self.$notify.error(data.message);
                    });
                } else {
                    self.firstStepError = "Ops!";
                }

                _ev.preventDefault();
            },
            setError() {
                this.secondStepError = 'Ops!'
            }
        }
    };
</script>